import { render, staticRenderFns } from "./outpatientVisits.vue?vue&type=template&id=30418118"
import script from "./outpatientVisits.vue?vue&type=script&lang=js"
export * from "./outpatientVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports